import styled from 'styled-components';
import { Body, Heading4 } from '@qover/typography';

export const Container = styled.div`
  background-color: ${props => props.theme.colors.cardBackground()};
  border-radius: ${props => props.theme.borders.cardRadius};
  border: solid 1px ${props => props.theme.colors.textQuote(0.1)};
  box-shadow: 0 2px 4px 0 ${props => props.theme.colors.textQuote(0.15)};
  overflow: hidden;
  position: relative;

  & + & {
    margin-top: 10px;

    @media screen and (min-width: ${({ theme }) =>
        theme.breakpoints.minWidth.S}) {
      margin-top: 20px;
    }
  }

  &.selected {
    border: solid 2px ${props => props.theme.colors.secondary()};
    .icon svg {
      fill: ${props => props.theme.colors.secondary()};
    }
  }

  .content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    .icon svg,
    .icon img {
      width: 40px;
      height: 40px;
    }
    .icon-text {
      display: flex;
      flex: 1 1 auto;
    }
    .icon + .text {
      margin-left: 20px;
    }

    .icon-text + .action {
      margin: 20px 0 0;
      margin-left: 0;
    }

    .add-option-button {
      margin-bottom: 10px;
    }
    .price + .insured-number {
      margin-left: 5px;
    }

    .action {
      flex-shrink: 0;
    }

    .price-container {
      text-align: center;
    }

    ${Heading4} {
      margin: 0 0 10px 0;
    }
  }
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.minWidth.XS}) {
    .content {
      padding: 40px;
      flex-direction: row;
      .icon svg,
      .icon img {
        width: 60px;
        height: 60px;
      }
      .icon-text + .action {
        margin: 0 0 0 20px;
      }
      .price-container {
        text-align: right;
      }
    }
  }
`;
